const initialState = {
    mockDraft: {
        url: "",
        link: ""
    },
    rankingsBuilder: {
        url: "",
        link: ""
    },
    reportsBuilder: {
        url: "",
        link: ""
    }
};

export const actionTypes = {
    fetchSponsors: 'SPONSORS_FETCH_SUCCESS',
}

const reducer = function(state, action){
    switch(action.type){
        case actionTypes.fetchSponsors:
            return {...state,
                    mockDraft: action.payload.mock_draft,
                    rankingsBuilder: action.payload.rankings_builder,
                    reportsBuilder: action.payload.reports_builder
            }
        default:
            return state;
    }
}

export const sponsorsReducer = [ 
    reducer,
    initialState
];